import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Map } from 'immutable';
import GraphSection from 'js/components/organisms/Section/Plot';
import * as modalActions from 'js/store/actions/modal';
import * as checkboxActions from '../../../store/reducers/country/plot/controls/dataShown/checkbox/actions';
import * as dropdownActions from '../../../store/reducers/country/plot/controls/dataShown/dropdown/actions';
import * as dataActions from '../../../store/reducers/country/plot/currentState/actions';
import * as plotDataActions from '../../../store/reducers/country/plot/data/actions';
import * as plotDataRangeActions from '../../../store/reducers/country/plot/controls/range/actions';
var actions = [checkboxActions, modalActions, dataActions, plotDataActions, plotDataRangeActions, dropdownActions];

function mapDispatchToProps(dispatch) {
  var _Map;

  var creators = (_Map = Map()).merge.apply(_Map, actions).filter(function (value) {
    return typeof value === 'function';
  }).toObject();

  return {
    actions: bindActionCreators(creators, dispatch),
    dispatch: dispatch
  };
}

function mapStateToProps(state, ownProps) {
  return {
    plot: ownProps.plot,
    windowWidth: state.device.windowWidth,
    isMobile: state.device.isMobileWidth
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(GraphSection);